import { useEffect, useState } from 'react';

/**
 * Notification displayed at the bottom of the viewport when in sandbox mode.
 * Shows that sandbox mode is not synchronized and data is stored locally.
 * Can be dismissed but reappears on page refresh.
 */
export function SandboxNotification(): React.JSX.Element | null {
  const [isDismissed, setIsDismissed] = useState(false);

  // Load dismissed state from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('warplan.sandbox-notification-dismissed');
    if (stored === 'true') {
      setIsDismissed(true);
    }
  }, []);

  if (isDismissed) {
    return null;
  }

  const handleDismiss = (): void => {
    setIsDismissed(true);
    // Note: does not persist to localStorage, so notification reappears on refresh
  };

  return (
    <div
      className="absolute bottom-4 left-1/2 z-40 -translate-x-1/2 rounded border border-orange-600 px-4 py-3 text-sm text-slate-900 shadow-lg"
      style={{
        backgroundColor: 'rgba(249, 115, 22, 0.65)',
      }}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3">
        <div className="flex-1">
          <p className="font-medium">Mode Sandbox — Données locales</p>
          <p className="text-xs opacity-90">Vos changements ne sont pas partagés et restent sur cet appareil.</p>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="ml-auto shrink-0 rounded p-1 hover:bg-orange-600/50 transition"
          aria-label="Fermer la notification"
          title="Fermer"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
